import { useEffect } from 'react';
import { isFunction } from 'lodash';

export const useButtonClick = (buttonKeyCode, handler) => {
  useEffect(() => {
    const onKeydown = ({ keyCode }) => {
      if (keyCode === buttonKeyCode && isFunction(handler)) handler();
    };
    document.addEventListener('keydown', onKeydown, true);
    return () => document.removeEventListener('keydown', onKeydown, true);
  }, [buttonKeyCode, handler]);
};

export default useButtonClick;
